import { render, staticRenderFns } from "./ProductTypeSelector.vue?vue&type=template&id=78ca051f&"
import script from "./ProductTypeSelector.vue?vue&type=script&lang=js&"
export * from "./ProductTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports